import { Component, OnInit } from '@angular/core';
import { ModelService } from '../../model.service';
import { NgForm } from '@angular/forms';
import { Challenge } from "../../classes/challenge";
import { DomSanitizer } from '@angular/platform-browser';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';


@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.component.html',
  styleUrls: ['./challenges.component.css'],
})
export class ChallengesComponent implements OnInit {

  uploadedImage: File;
  imagePreview: string;
  combinedChallenges: number[];
  highlightedRowsArray: number[];
  selectedRow: Challenge;
  challenges: Challenge[];




  combineLimit = 2; //This will give an array size of 3....
  highLightedRow = -1;
  submitBtn = 'Submit';
  combineBtn = 'Combine';
  title = "Challenges";
  location = "";
  user_comment = "";


  showDialog = false;
  showLoading = false;
  showUploading = false;
  image = null;
  image_reduced = null;

  user = JSON.parse(localStorage.getItem('currentUser'));
  user_name = this.user.name;
  team_name = this.user.team_name;
  fullImageLoadingPath = '/assets/images/loading.gif';
  fullImageUploadingPath = '/assets/images/uploading5.gif';



  //Constructor for the various Services
  constructor(
    private modelService: ModelService,
    private ng2ImgMax: Ng2ImgMaxService,
    public sanitizer: DomSanitizer,
    private router: Router
  ) { }


  //Initialiser function, called when the component is active.
  ngOnInit() {
    this.getChallenges();
    this.combinedChallenges = new Array();
    this.highlightedRowsArray = new Array();
  }

  //Ask the model service to retrieve a list of challenges from the DB.
  getChallenges(): void {
    this.modelService.getChallenges().subscribe(
      challenges => {this.challenges = challenges},
      err => {
      console.log("Error occured.")
      this.router.navigateByUrl('login');
    });
  }

  onKey(event: any) { // without type info
    this.user_comment = event.target.value;
  }

  //Called on the submit button in the dialog. Will attempt to upload sumbmission data to the DB
  submit() {
    //Change the text on the submit button
    this.submitBtn = "Wait"
    //If the image preview is empty, throw an alert.
    if (this.imagePreview == null) {
      alert('Oops you forgot to upload an image or it didn\'t work correctly. ');
    }

    //Strip the unecessary data from the beginning of the base64 image before sending.
    this.image_reduced = this.imagePreview.replace(/data:;base64,/, "");

    //prepare the js object to send to DB
    var js_obj = {
      id: this.selectedRow.id,
      status: 'submitted',
      points: this.selectedRow.points,
      media: this.image_reduced,
      text: this.user_comment,
      combinedChallenges: this.combinedChallenges
      //challenge_id: this.selectedRow.id,
    };
    var encoded = JSON.stringify(js_obj);
    var dataObj = encoded;
    console.log(dataObj);

    //Call the modelService to post the created js object.
    this.showUploading = true;
    this.submitBtn = '';
    this.combineBtn = '';
    this.modelService.postSubmission(dataObj).subscribe(
      data => {
        //When an Observable returns, show an alert.
        alert('Upload Success')
        this.showUploading = false;
        this.router.navigateByUrl('submissions');
      },
      err => {
        //console.log("Error occured.");
        this.showUploading = false;
        this.submitBtn = "Retry"
      }
    );
  }

  //So the NgFor can get and index and pass the selected row to the component.
  setClickedRow(index): void {
    this.selectedRow = index;
    //console.log(this.selectedRow);
    //makes sure that any previously uploaded images are cleared.
    this.imagePreview = null;
  }

  //Called when the cancel button is pressed on the modal.
  cancel(): void {
    //This will ensure that the arrays are emptied.
    this.combinedChallenges = [];
    this.highlightedRowsArray = [];
    //console.log("cancel pressed");
  }

  //Add challenge_ids to the combinedChallenges Array to keep track of which three have been selected.
  //It also tracks which rows have been added and which to remove fo highlighting in the dailog.
  //Lazy implmentation, could do with an upgrade.
  //A maximum of three is currently allowed.
  toggleCombinedChallenge(challenge_id, index): void {

    var pos = this.combinedChallenges.indexOf(challenge_id);

    if ((this.combinedChallenges.length <= this.combineLimit) && (!this.combinedChallenges.includes(challenge_id))) {
      //array is less than 3 large and the index is not already there. Add it.
      this.combinedChallenges.push(challenge_id);
      this.highlightedRowsArray.push(index);
    }
    //If it is less than 3, but it is there.
    else if ((this.combinedChallenges.length <= this.combineLimit) && (this.combinedChallenges.includes(challenge_id))) {
      //get the index of where the current object is and remove it.
      this.combinedChallenges.splice(this.combinedChallenges.indexOf(challenge_id), 1);
      this.highlightedRowsArray.splice(this.highlightedRowsArray.indexOf(index), 1);
    }
    //If it is greater than 3, but it is there
    else if ((this.combinedChallenges.length >= this.combineLimit) && (this.combinedChallenges.includes(challenge_id))) {
      //get the index of where the current onject is and remove it.
      this.combinedChallenges.splice(this.combinedChallenges.indexOf(challenge_id), 1);
      this.highlightedRowsArray.splice(this.highlightedRowsArray.indexOf(index), 1);
    }
    //If it is greater than 3, but it is not there
    else if ((this.combinedChallenges.length >= this.combineLimit) && (!this.combinedChallenges.includes(challenge_id))) {
      //remove the first object.
      this.combinedChallenges.splice(0, 1);
      //add in the new object.
      this.combinedChallenges.push(challenge_id);
      this.highlightedRowsArray.splice(0, 1);
      this.highlightedRowsArray.push(index);
    }
  }

  //Check for an uploaded image.
  changeListener($event): void {
    this.readThis($event.target);
  }

  //convert the uploaded file to Base 64.
  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
    }
    myReader.readAsDataURL(file);
  }


  onImageChange(event) {
    console.log("somehting uploaded")
    this.showLoading = true;
    let image = event.target.files[0];


    this.ng2ImgMax.resizeImage(image, 800, 450).subscribe(
    //this.ng2ImgMax.compressImage(image, .06, true).subscribe(
      result => {
        this.uploadedImage = new File([result], result.name);
        this.showLoading = false;
        this.getImagePreview(this.uploadedImage);
        console.log("image resized");
      },
      error => {
        console.log('Oh no, error while resizing!', error);
      }
    );
  }

  ////Original Onimage Change.
  // onImageChange(event) {
  //   console.log("somehting uploaded")
  //   let image = event.target.files[0];
  //   this.showLoading = true;
  //
  //   this.ng2ImgMax.resizeImage(image, 550, 450).subscribe(
  //     result => {
  //       this.uploadedImage = new File([result], result.name);
  //       this.showLoading = false;
  //       this.getImagePreview(this.uploadedImage);
  //     },
  //     error => {
  //       console.log('Oh no!', error);
  //     }
  //   );
  // }

  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imagePreview = reader.result;
      console.log(this.imagePreview);
      var trp = "application/octet-stream";
      this.imagePreview = this.imagePreview.replace(trp, "");
      console.log("REMOVED*** " + this.imagePreview + " ***");
    };
  }

  // Prevent from exiting app by hook into document backbutton
  @HostListener('document:backbutton', ['$event'])
  onPopState(event) {
    alert('Start page');
  }

}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/content/challenges/challenges.component.ts